import type { Query } from "@tanstack/react-query";

/**
 * Counts component-driven fetches only. Route loaders go through `ensureQueryData`
 * (no observer) and hover preload never flips `status` — the `busy` prop covers those.
 * Neither signal alone is enough.
 */
const isOverlayQuery = (query: Query): boolean =>
  query.getObserversCount() > 0 && query.meta?.skipGlobalLoader !== true;

export { isOverlayQuery };
